import { makeStyles } from "@material-ui/core";
import { useRecoilState } from "recoil";
import FlightPathModeState from "../../store/FlightPathModeState";
import link from "../../images/contents/crosssection/link.png";
import unlink from "../../images/contents/crosssection/unlink.png";

const useStyles = makeStyles(() => ({
  img: {
    left: -4,
    top: 3,
    width: 29,
    cursor: "pointer",
    height: 29,
    position: "relative"
  },
  linkCushion: {
    width: 21,
    height: 34,
    zIndex: 100,
    position: "fixed",
    backgroundColor: "rgba(127, 127, 127, 0.6)"
  },
  panelWrap: {
    bottom: 16,
    left: 8,
    position: "absolute"
  }
}));
  
  function CsModeChangePanel() {
    const [mode, setMode] = useRecoilState(FlightPathModeState);
    const classes = useStyles();
    
    const toggleFlightPathMode = () => {
      setMode(!mode);
    };

    return (
      <div className={classes.panelWrap}>
        <div className={classes.linkCushion}>
          <img src={mode ? unlink : link} alt="link" className={classes.img} onClick={toggleFlightPathMode} />
        </div>
      </div>
    );
  }  

  export default CsModeChangePanel;